<template>
  <div class="repair-order" v-loading="loading">
    <el-tabs v-model="searchData.ApplyInstallStatus" @tab-click="searchBtn">
      <el-tab-pane label="待处理" name="1"></el-tab-pane>
      <el-tab-pane label="已完成" name="2"></el-tab-pane>
      <el-tab-pane label="已拒绝" name="3"></el-tab-pane>
    </el-tabs>
    <div class="search-box">
      <el-form :inline="true">
        <el-form-item label="订单号：">
          <el-input v-model="searchData.SearchKey" placeholder="订单号"></el-input>
        </el-form-item>
        <el-form-item label="联系人：">
          <el-input v-model="searchData.ContactName" placeholder="联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：">
          <el-input v-model="searchData.ContactPhone" placeholder="联系电话"></el-input>
        </el-form-item>
        <el-form-item label="分销商">
          <el-select v-model="ResellerId" filterable remote :remote-method="remoteReseller" placeholder="分销商"
            style="width:100%;">
            <el-option v-for="(item, index) in resellerList" :key="index" :label="item.value"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间">
          <el-date-picker v-model="value" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker"></el-date-picker>
        </el-form-item>
        <el-form-item label="型号：">
          <el-input v-model="searchData.ModelCode" placeholder="型号"></el-input>
        </el-form-item>
        <el-form-item label="报装时间">
          <el-date-picker v-model="value1" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePickerInstall"></el-date-picker>
        </el-form-item>
        <el-form-item label="报装时效：">
          <el-select v-model="searchData.InstallTimeRange">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="半小时内" :value="1"></el-option>
            <el-option label="半小时到两小时" :value="2"></el-option>
            <el-option label="超过两小时" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
          <el-button type="primary" plain @click="resetBtn">重置</el-button>
          <el-button type="success" @click="batchUpadate" v-if="searchData.ApplyInstallStatus == 1">批量付费报装</el-button>
        </el-form-item>
        <el-form-item>
          <div style="display: flex;">
            <el-button type="primary" @click="batchBarCodeUpdate"
              v-if="searchData.IsBarCodeBind === 'false'">批量手动匹配成功</el-button>
            <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="tab-box">
      <el-table border :data="tableData" @selection-change="selectCurrentRow">
        <el-table-column type="selection" width="50" fixed align="center"
          v-if="searchData.ApplyInstallStatus == 1"></el-table-column>
        <el-table-column label="订单号" prop="ChildOrderNo" align="center" min-width="300">
          <template slot-scope="scope">
            <p>{{ scope.row.childOrderNo }}</p>
            <el-tag size="mini" type="success" v-if="scope.row.thirdOrderId">外部订单号：{{ scope.row.thirdOrderId }}</el-tag>
            <time-count :time="scope.row.createTime"
              v-if="searchData.ApplyInstallStatus == 1 && !scope.row.isNotForceInstall" />
            <p v-if="scope.row.isTimeoutInstall && searchData.ApplyInstallStatus == 2" style="color:red;">已超时，自动报装</p>
          </template>
        </el-table-column>
        <el-table-column label="下单台数" prop="skuNumber" align="center" min-width="100"></el-table-column>
        <el-table-column label="报装台数" prop="applyNumber" align="center" min-width="100"></el-table-column>
        <el-table-column label="型号" prop="modelCode" align="center" min-width="200"></el-table-column>
        <!-- <el-table-column label="采购供应商" prop="" align="center" min-width="200">
          <template slot-scope="scope" v-if="scope.row.PurchaseInfo">
            <el-tag size="mini" class="purchaseInfo" type="success"
              v-for="(item, i) in JSON.parse(scope.row.PurchaseInfo)" :key="i">
              {{ item.supplierName }}
            </el-tag>
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="商户账号" prop="AccountUsername" align="center" min-width="150"></el-table-column> -->
        <el-table-column label="报装联系人" prop="contactName" align="center" min-width="100"></el-table-column>
        <el-table-column label="联系电话" prop="contactPhone" align="center" min-width="150"></el-table-column>
        <el-table-column label="上门地址" min-width="200" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.provinceName">{{ scope.row.provinceName }} - </span>
            <span v-if="scope.row.cityName">{{ scope.row.cityName }} - </span>
            <span v-if="scope.row.districtName">{{ scope.row.districtName }} - </span>
            <span v-if="scope.row.address">{{ scope.row.address }}</span>
          </template>
        </el-table-column>
        <el-table-column label="下单地址" min-width="200" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.rProvinceName">{{ scope.row.rProvinceName }} - </span>
            <span v-if="scope.row.rCityName">{{ scope.row.rCityName }} - </span>
            <span v-if="scope.row.rDistrictName">{{ scope.row.rDistrictName }} - </span>
            <span v-if="scope.row.rAddress">{{ scope.row.rAddress }}</span>
          </template>
        </el-table-column>
        <el-table-column label="条形码" min-width="200" align="center">
          <template slot-scope="scope">
            <el-image style="width:60px;height:60px;margin: 0 10px 10px 0;" v-for="(pic, i) in splitArr(scope.row.pic)"
              :key="i" :src="pic" :preview-src-list="splitArr(scope.row.pic)" :z-index=3000
              @click.stop="handleClickItem">
            </el-image>
          </template>
        </el-table-column>
        <!-- <el-table-column label="物流面单" min-width="200" align="center">
          <template slot-scope="scope">
            <el-image style="width:60px;height:60px;margin: 0 10px 10px 0;"
              v-for="(pic, i) in splitArr(scope.row.LogisticsPic)" :key="i" :src="pic"
              :preview-src-list="splitArr(scope.row.LogisticsPic)" :z-index=3000 @click.stop="handleClickItem">
            </el-image>
          </template>
        </el-table-column> -->
        <el-table-column label="申请时间" prop="createTime" align="center" min-width="200"></el-table-column>
        <el-table-column label="报装状态" min-width="200" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">处理中</span>
            <span v-if="scope.row.status == 2">已完成</span>
            <span v-if="scope.row.status == 3">已拒绝</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="备注信息" prop="Remark" align="center" min-width="150"></el-table-column> -->
        <el-table-column label="报装时间" prop="installTime" align="center"></el-table-column>
        <el-table-column label="报装时效" prop="" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.installTimeRange == 1">半小时内</span>
            <span v-if="scope.row.installTimeRange == 2">半小时到两小时</span>
            <span v-if="scope.row.installTimeRange == 3">超过两小时</span>
          </template>
        </el-table-column>
        <el-table-column label="报装金额" prop="installAmount" align="center"></el-table-column>
        <el-table-column label="处理备注" prop="" align="center" min-width="200">
          <template slot-scope="scope">
            <div v-for="(va, i) in scope.row.remarks" :key="i">
              <span>操作人：{{ va.createBy }}</span>
              <span>操作时间：{{ va.createTime }}</span>
              <span>备注：{{ va.remark }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="270" fixed="right">
          <template slot-scope="scope">
            <el-button style="margin-bottom: 10px;" type="primary" size="small"
              @click="handleBarcode(scope.row)">条码</el-button>
            <el-button style="margin-bottom: 10px;" v-if="scope.row.status == 1" @click="handle(scope.row)"
              type="primary" size="small">处理</el-button>
            <el-button style="margin-bottom: 10px;" @click="handleRecord(scope.row)" type="primary"
              size="small">处理记录</el-button>
            <!-- <el-button style="margin-bottom: 10px;" @click="handleOrderDetail(scope.row)" type="primary" size="small">订单详情</el-button> -->
            <!-- <el-button style="margin-bottom: 10px;" v-if="scope.row.Status == 1 && isOperateBtn"
              @click="handleDelete(scope.row)" type="danger" size="small">删除</el-button>
            <el-button style="margin-bottom: 10px;" type="primary" size="small"
              @click="copyText(scope.row)">复制报装信息</el-button>
            <el-button style="margin-bottom: 10px;" type="primary" size="small"
              @click="remarkBtn(scope.row)">备注信息</el-button>
            <el-button v-if="scope.row.Status == 1" style="margin-bottom: 10px;" type="primary" size="small"
              @click="modifykBtn(scope.row)">修改</el-button>
            <el-button style="margin-bottom: 10px;" type="primary" size="small"
              @click="applyInstallRobotTime(scope.row)">已跑</el-button>
            <el-button style="margin-bottom: 10px;" type="primary" size="small"
              v-if="searchData.IsBarCodeBind === 'false'" @click="batchBarCodeUpdate(scope.row)">匹配成功</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="searchData.PageIndex" :total="total"
        :page-sizes="[10, 20, 30, 40, 50, 100]" style="float: right"></el-pagination>
    </div>
    <!-- 处理 -->
    <el-dialog title="处理" v-if="handleDialog" :visible.sync="handleDialog" :close-on-click-modal="false">
      <el-form label-width="120px" @submit.native.prevent :model="handleForm" ref="handleForm">
        <el-form-item label="是否安装完成：">
          <el-radio-group v-model="handleForm.Status">
            <el-radio :label="1">处理中</el-radio>
            <el-radio :label="2">已完成</el-radio>
            <el-radio :label="3">已拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="handleForm.Remark">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDialog = false">取消</el-button>
        <el-button type="primary" @click.native="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
    <!-- 处理记录 -->
    <el-dialog title="处理记录" v-if="handleRecordDialog" :visible.sync="handleRecordDialog" :close-on-click-modal="false"
      width="70%">
      <el-table border :data="handleRecordData" :header-cell-style="{ background: '#F3F3F3' }">
        <el-table-column min-width="100" align="center" label="处理人">
          <template slot-scope="scope">
            <div style="display:flex;justify-content:center;position:relative;">
              <div v-if="scope.row.status == 1" style="position:absolute;left:15%;"><i class="el-icon-time"
                  style="color:#F56C6C;"></i></div>
              <div v-if="scope.row.status == 2" style="position:absolute;left:15%;"><i class="el-icon-circle-check"
                  style="color:#67C23A;"></i></div>
              <div><span>{{ scope.row.createBy }}</span></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否安装完成" min-width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">处理中</span>
            <span v-if="scope.row.status == 2">已完成</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" min-width="100" align="center" label="操作时间">
        </el-table-column>
        <el-table-column prop="remark" min-width="150" align="center" label="备注">
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 条码 -->
    <el-dialog title="条码" :visible.sync="dialogVisibleBarcode" :close-on-click-modal="false" width="70%">
      <el-form inline>
        <el-form-item label="匹配状态">
          <el-select v-model="codeForm.IsBind">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="匹配成功" :value="true"></el-option>
            <el-option label="匹配失败" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单安装地址是否匹配">
          <el-select v-model="codeForm.IsAddressCheck">
            <el-option label="全部" :value="null"></el-option>
            <el-option label="是" :value="true"></el-option>
            <el-option label="否" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchCode">搜索</el-button>
          <el-button type="danger" @click="resetCode">重置</el-button>
          <el-button type="primary" @click="copyInfo">复制信息</el-button>
        </el-form-item>
      </el-form>
      <el-table border :data="barcodeList" :header-cell-style="{ background: '#F3F3F3' }">
        <el-table-column min-width="100" align="center" prop="Code" label="ocr识别结果">
          <template slot-scope="scope">
            <el-input v-model="scope.row.code"></el-input>
            <el-button type="primary" size="small" @click="changeCode(scope.row)"
              style="margin-top: 10px;">匹配</el-button>
            <el-button type="primary" size="small" @click="copyCode(scope.row)" style="margin-top: 10px;">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column label="已确认条码" min-width="100" align="center">
          <template slot-scope="scope"> {{ scope.row.isBind ? scope.row.code : '/' }}</template>
        </el-table-column>
        <el-table-column min-width="100" align="center" prop="Code" label="条形码">
          <template slot-scope="scope">
            <el-image style="width:60px;height:60px;margin: 0 10px 10px 0;" :src="scope.row.codePic"
              :preview-src-list="splitArr(scope.row.codePic)" :z-index=3000 @click.stop="handleClickItem">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="物流面单" min-width="200" align="center">
          <template slot-scope="scope">
            <el-image style="width:60px;height:60px;margin: 0 10px 10px 0;" :src="scope.row.logisticsPic"
              :preview-src-list="splitArr(scope.row.logisticsPic)" :z-index=3000 @click.stop="handleClickItem">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" min-width="100" align="center" label="是否匹配成功">
          <template slot-scope="scope"> {{ scope.row.isBind ? '匹配成功' : '匹配失败' }}</template>
        </el-table-column>
        <el-table-column prop="Remark" min-width="100" align="center" label="下单安装地址是否匹配">
          <template slot-scope="scope"> {{ scope.row.isAddressCheck ? '是' : '否' }}</template>
        </el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeCode" :total="codeTotal"
        @current-change="handleCurrentCode">
      </el-pagination>
    </el-dialog>
    <!-- <el-dialog title="导入数据" width="30%" :visible.sync="bindVisible" :show-file-list="false"
      :close-on-click-modal="false">
      <div class="updata_view" v-loading="uploading" element-loading-text="正在上传...">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :on-change="updata">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx文件
            <el-button type="text" @click="upDataInfo">下载导入模板</el-button>
          </div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleExpSubmit">确 定</el-button>
      </span>
    </el-dialog> -->
    <!-- 修改 -->
    <!-- <el-dialog title="修改" center :visible.sync="dialogModifykVisible" :close-on-click-modal="false">
      <el-form label-width="120px">
        <el-form-item label="订单号：">
          <el-input v-model="modifyForm.ChildOrderNo"></el-input>
        </el-form-item>
        <el-form-item label="报装台数：">
          <el-input v-model="modifyForm.ApplyNumber"></el-input>
        </el-form-item>
        <el-form-item label="报装联系人：">
          <el-input v-model="modifyForm.ContactName"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：">
          <el-input v-model="modifyForm.ContactPhone"></el-input>
        </el-form-item>
        <el-form-item label="上门地址：">
          <el-select v-model="modifyForm.ProvinceName" placeholder="省" @change="handleProvince" value-key="Id"
            style="width: 33%">
            <el-option v-for="item in provinceList" :key="item.Id" :label="item.AreaName" :value="item">
            </el-option>
          </el-select>
          <el-select v-model="modifyForm.CityName" placeholder="市" @change="handleCity" value-key="Id"
            style="width:  33%">
            <el-option v-for="item in cityList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
          </el-select>
          <el-select v-model="modifyForm.DistrictName" placeholder="区" @change="handleArea" value-key="Id"
            style="width:  33%">
            <el-option v-for="item in areaList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址：">
          <el-input v-model="modifyForm.Address"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="submitModify">保 存</el-button>
      </div>
    </el-dialog> -->
    <!-- 批量报装 -->
    <el-dialog title="批量报装" v-if="batchUpdateDialog" :visible.sync="batchUpdateDialog" :close-on-click-modal="false"
      width="70%">
      <div class="updateTitle">优惠报装<span>未超过30分钟的报装单，以优惠金额报装</span></div>
      <el-table border :data="batchData.discountGroup" :header-cell-style="{ background: '#F3F3F3' }">
        <el-table-column align="center" label="订单号" prop="childOrderNo"></el-table-column>
        <el-table-column align="center" label="品牌" prop="brand"></el-table-column>
        <el-table-column align="center" label="型号" prop="modelCode"></el-table-column>
        <el-table-column align="center" label="报装台数" prop="skuNumber"></el-table-column>
        <el-table-column align="center" label="空调类型" prop="installType"></el-table-column>
        <el-table-column align="center" label="报装人" prop="contactName"></el-table-column>
        <el-table-column align="center" label="联系电话" prop="contactPhone"></el-table-column>
        <el-table-column align="center" label="单价/台" prop="price"></el-table-column>
        <el-table-column align="center" label="总金额" prop="amount"></el-table-column>
      </el-table>
      <div class="updateTitle" style="margin-top:20px;">正常报装<span>超过30分钟但未超过2小时的报装单，以原价报装</span></div>
      <el-table border :data="batchData.normalGroup" :header-cell-style="{ background: '#F3F3F3' }">
        <el-table-column align="center" label="订单号" prop="childOrderNo"></el-table-column>
        <el-table-column align="center" label="品牌" prop="brand"></el-table-column>
        <el-table-column align="center" label="型号" prop="modelCode"></el-table-column>
        <el-table-column align="center" label="报装台数" prop="skuNumber"></el-table-column>
        <el-table-column align="center" label="空调类型" prop="installType"></el-table-column>
        <el-table-column align="center" label="报装人" prop="contactName"></el-table-column>
        <el-table-column align="center" label="联系电话" prop="contactPhone"></el-table-column>
        <el-table-column align="center" label="单价/台" prop="price"></el-table-column>
        <el-table-column align="center" label="总金额" prop="amount"></el-table-column>
      </el-table>
      <div slot="footer">
        <span style="margin-right:15px;">合计金额：<span style="color:red;">￥{{ batchData.totalAmount }}</span></span>
        <el-button type="primary" @click="submitBatchUpdate">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  KSAXApiRequest,
  GetAllReseller,
  ApplyInstallList,
  ApplyInstallStatusChange,
  ApplyInstallDelete,
  BindExternalInstall,
  BarCodeList,
  BarCodeUpdate,
  ApplyInstallRemark,
  ExportApplyInstallList,
  busSupplierList,
  ThemeSort,
  ChildOrderBatchBarCodeUpdate,
  areaList,
  ApplyInstallUpdate,
  ApplyInstallRobotTime
} from '../../api/api'
import toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import autocomplete from "../../components/autocomplete";
import timeCount from "./timeCount"
export default {
  components: { toolbar, autocomplete, timeCount },
  data() {
    return {
      buttonList_toolBar: [],
      buttonList_table: [],
      tableData: [],
      total: 0,
      ResellerId: null,
      searchData: {
        AccountId: null,
        SearchKeyType: 1,
        SearchKey: null,
        ModelCode: null,
        AccountType: null,
        ApplyInstallStatus: '1',
        ContactPhone: null,
        ContactName: null,
        StartTime: null,
        EndTime: null,
        InstallTimeBegin: null,
        InstallTimeEnd: null,
        InstallTimeRange: null,
        PageIndex: 1,
        PageSize: 10,
        // SupIds: [],
        SupName: '',
        // IsBarCodeBind: "true",
        IsRobot: null,
        SelectNumber: -1,
        RemainNumber: 3
      },
      remarkList: [],
      formData: {
        applyInstallId: null,
        remark: "",
      },
      value: [],
      value1: [],
      handleDialog: false,
      handleForm: {
        ApplyInstallId: 0,
        Status: 2,
        Remark: null,
      },

      handleRecordDialog: false,
      handleRecordData: [],
      isOperateBtn: false,
      isOperateRecord: false,
      bindVisible: false,
      uploading: false,
      dialogVisibleBarcode: false,
      codeForm: {
        OriginInstallId: null,
        IsBind: null,
        IsAddressCheck: null,
        PageIndex: 1,
        PageSize: 10
      },
      barcodeList: [],
      codeTotal: 0,
      supmodelData: {
        name: "",
        restaurants: [],
      },
      supLoading: false,
      loading: false,
      checkedData: [],
      // dialogModifykVisible: false,
      // modifyForm: {
      //   "Id": null,
      //   "ChildOrderNo": "",
      //   "ApplyNumber": null,
      //   "ContactName": "",
      //   "ContactPhone": "",
      //   "ProvinceId": null,
      //   "ProvinceName": "",
      //   "CityId": null,
      //   "CityName": "",
      //   "DistrictId": null,
      //   "DistrictName": "",
      //   "Address": ""
      // },
      // provinceList: [],
      // cityList: [],
      // areaList: [],
      row: {},
      batchUpdateDialog: false,
      batchData: {},
      resellerList: []
    }
  },
  created() {
    this.getResellerId()
    // this.getBusSupplierList();
    // this.getProvinceList()
  },
  methods: {
    batchUpadate() {
      if (!this.checkedData.length) return this.$message.error('请先选择数据!')
      let _data = {
        "path": "Order_ApplyInstall/GetBatchApplyInstallInfo",
        "parms": "",
        "parmsJson": { ApplyInstallIds: this.checkedData.map(i => i.applyInstallId) }
      }
      KSAXApiRequest(_data).then((res) => {
        res.data.response.discountGroup = res.data.response.discountGroup || []
        res.data.response.normalGroup = res.data.response.normalGroup || []
        this.batchData = res.data.response
      });
      this.batchUpdateDialog = true
    },
    submitBatchUpdate() {
      this.$confirm("确认报装吗?", "提示", {
        closeOnClickModal: false,
      })
        .then(() => {
          let _data = {
            "path": "Order_ApplyInstall/BatchApplyInstall ",
            "parms": "",
            "parmsJson": { ApplyInstallIds: this.checkedData.map(i => i.applyInstallId), TotalAmount: this.batchData.totalAmount }
          }
          KSAXApiRequest(_data).then((res) => {
            if (res.data.success) {
              this.$message.success('提交成功')
              this.batchUpdateDialog = false
              this.getTableData()
            } else {
              this.$message.error(res.data.msg)
            }
          });
        })
        .catch(() => {
        });
    },
    getResellerId() {
      GetAllReseller({ SkipCount: 0, MaxResultCount: 10 }).then(res => {
        if (res.data.success) {
          this.ResellerId = res.data.result.items[0].remoteKey
          this.resellerList = res.data.result.items.map((item) => {
            return {
              value: item.name,
              id: item.remoteKey,
              supType: item.supType
            };
          });
          this.getTableData()
        }
      })
    },
    remoteReseller(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100
      }
      if (key) {
        obj.Name = key;
      }
      return new Promise((resolve, reject) => {
        GetAllReseller(obj).then((res) => {
          if (res.data.success) {
            this.resellerList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.remoteKey,
                supType: item.supType
              };
            });
            resolve(this.resellerList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    getTableData() {
      let data = {
        ...this.searchData,
        // IsBarCodeBind: JSON.parse(this.searchData.IsBarCodeBind), 
        supIds: [Number(this.ResellerId)]
      }
      if (!data.AccountId) {
        data.AccountId = 0
      }
      this.tableData = []
      this.loading = true
      let _data = {
        "path": "Order_ApplyInstall/ApplyInstallDataList",
        "parms": "",
        "parmsJson": data
      }
      KSAXApiRequest(_data).then((res) => {
        this.loading = false;
        // res.data.response.data[0].createTime = '2026-07-15 11:30:00'
        // res.data.response.data[1].createTime = '2026-07-15 09:50:00'
        this.tableData = res.data.response.data || [];
        this.total = res.data.response.dataCount || 0;
      });
    },
    handleCurrentChange(val) {
      this.searchData.PageIndex = val;
      this.getTableData();
    },
    handleSizeChange(e) {
      this.searchData.PageSize = e;
      this.getTableData();
    },
    // modifykBtn(row) {
    //   this.modifyForm.Id = row.ApplyInstallId
    //   this.modifyForm.ChildOrderNo = row.ChildOrderNo
    //   this.modifyForm.ApplyNumber = row.ApplyNumber
    //   this.modifyForm.ContactName = row.ContactName
    //   this.modifyForm.ContactPhone = row.ContactPhone
    //   this.modifyForm.ProvinceId = row.ProvinceId
    //   this.modifyForm.ProvinceName = row.ProvinceName
    //   this.modifyForm.CityId = row.CityId
    //   this.modifyForm.CityName = row.CityName
    //   this.modifyForm.DistrictId = row.DistrictId
    //   this.modifyForm.DistrictName = row.DistrictName
    //   this.modifyForm.Address = row.Address
    //   this.dialogModifykVisible = true
    // },
    // submitModify() {
    //   let flage = false
    //   for (var i in this.modifyForm) {
    //     if (!this.modifyForm[i]) {
    //       flage = true
    //     }
    //   }
    //   if (flage) {
    //     return this.$message.error('请填写完整信息!')
    //   }
    //   this.$confirm("确定提交吗?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     closeOnClickModal: false,
    //     type: "warning",
    //   }).then(() => {
    //     ApplyInstallUpdate(this.modifyForm).then(res => {
    //       if (res.data.success) {
    //         this.$message.success(res.data.msg)
    //       } else {
    //         this.$message.error(res.data.msg)
    //       }
    //     })
    //   })
    // },
    // getProvinceList() {
    //   let that = this;
    //   let params = {
    //     areaLevel: 1,
    //   };
    //   areaList(params).then((res) => {
    //     that.provinceList = res.data.response.data;
    //   });
    // },
    // getCityList() {
    //   // 市
    //   let that = this;
    //   let params = {
    //     areaLevel: 2,
    //     parentId: that.modifyForm.ProvinceId,
    //   };
    //   areaList(params).then((res) => {
    //     that.cityList = res.data.response.data;
    //     if (that.modifyForm.CityId) {
    //       that.getAreaList();
    //     }
    //   });
    // },
    // getAreaList() {
    //   // 区
    //   let that = this;
    //   let params = {
    //     areaLevel: 3,
    //     parentId: that.modifyForm.CityId,
    //   };
    //   areaList(params).then((res) => {
    //     that.areaList = res.data.response.data;
    //   });
    // },
    // handleProvince(e) {
    //   // 赋值省
    //   this.modifyForm.ProvinceId = e.Id;
    //   this.modifyForm.ProvinceName = e.AreaName;
    //   this.modifyForm.CityId = null;
    //   this.modifyForm.CityName = null;
    //   this.modifyForm.DistrictId = null;
    //   this.modifyForm.DistrictName = null;
    //   this.getCityList();
    // },
    // handleCity(e) {
    //   // 赋值市
    //   this.modifyForm.CityId = e.Id;
    //   this.modifyForm.CityName = e.AreaName;
    //   this.modifyForm.DistrictId = null;
    //   this.modifyForm.DistrictName = null;
    //   this.getAreaList();
    // },
    // handleArea(e) {
    //   // 赋值区
    //   this.modifyForm.DistrictId = e.Id;
    //   this.modifyForm.DistrictName = e.AreaName;
    // },
    // remoteMethod(query) {
    //   if (query !== '') {
    //     this.supLoading = true;
    //     this.getBusSupplierList(query, () => {
    //       this.supLoading = false;
    //     })
    //   } else {
    //     // this.options = [];
    //   }
    // },
    // handleSupInput(e) {
    //   this.getBusSupplierList(e);
    // },
    // handleSupSelect(e) {
    //   this.searchData.SupId = e.id;
    // },
    //获取供应商列表
    // getBusSupplierList(e, cb) {
    //   let that = this;
    //   let params = {
    //     supName: e ? e : "",
    //     pageIndex: 1,
    //     pageSize: 100,
    //   };
    //   busSupplierList(params).then((res) => {
    //     let list = [];
    //     res.data.response.data.forEach((v, i) => {
    //       list[i] = {
    //         value: v.SupName,
    //         id: v.Id,
    //       };
    //     });
    //     that.supmodelData.restaurants = list;
    //     cb()
    //   });
    // },
    handlePicker(date) {
      if (date == null) {
        date = []
      }
      this.searchData.StartTime = date[0]
      this.searchData.EndTime = date[1]
    },
    handlePickerInstall(date) {
      if (date == null) {
        date = []
      }
      this.searchData.InstallTimeBegin = date[0]
      this.searchData.InstallTimeEnd = date[1]
    },
    exportBtn() {
      let data = { ...this.searchData, IsBarCodeBind: JSON.parse(this.searchData.IsBarCodeBind) }
      if (!data.AccountId) {
        data.AccountId = 0
      }
      ExportApplyInstallList(data).then(res => {
        if (res.data.success) {
          this.$message.success('请前往下载中心查看')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // copyText(row) {
    //   const inputDom = document.createElement('textarea');
    //   document.body.appendChild(inputDom)
    //   inputDom.value = `${row.ContactName}${row.ContactPhone}${row.ProvinceName}${row.CityName}${row.DistrictName}${row.Address}`
    //   inputDom.select()
    //   inputDom.focus()
    //   document.execCommand('copy')
    //   document.body.removeChild(inputDom)
    //   this.$message.success('复制成功')
    // },
    copyCode(row) {
      const inputDom = document.createElement('textarea');
      document.body.appendChild(inputDom)
      inputDom.value = `${row.code}`
      inputDom.select()
      inputDom.focus()
      document.execCommand('copy')
      document.body.removeChild(inputDom)
      this.$message.success('复制成功')
    },
    // remarkBtn(row) {
    //   this.$prompt('请输入备注信息', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     inputPattern: /\S/,
    //     inputErrorMessage: '请输入备注信息'
    //   }).then(({ value }) => {
    //     let params = {
    //       ApplyInstallId: row.ApplyInstallId,
    //       Remark: value
    //     }
    //     ApplyInstallRemark(params).then(res => {
    //       if (res.data.success) {
    //         this.$message.success(res.data.msg)
    //         this.getTableData()
    //       } else {
    //         this.$message.error(res.data.msg)
    //       }
    //     })
    //   }).catch(() => { });
    // },
    callFunction(item) {
      this[item.Func](item);
    },
    changeCode(row) {
      let data = {
        id: row.id,
        code: row.code
      }
      let _data = {
        "path": "ChildOrder/BarCodeUpdate",
        "parms": "",
        "parmsJson": data
      }
      KSAXApiRequest(_data).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg)
          this.getBarCodeList()
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    handleBarcode(row) {
      this.row = row
      this.dialogVisibleBarcode = true
      this.codeForm.OriginInstallId = row.applyInstallId
      this.getBarCodeList()
    },
    handleSizeCode(val) {
      this.codeForm.PageSize = val
      this.getBarCodeList()
    },
    handleCurrentCode(val) {
      this.codeForm.PageIndex = val
      this.getBarCodeList()
    },
    searchCode() {
      this.codeForm.PageIndex = 1
      this.getBarCodeList()
    },
    resetCode() {
      this.codeForm.PageIndex = 1
      this.codeForm.PageSize = 10
      this.codeForm.IsBind = null
      this.codeForm.IsAddressCheck = null,
        this.getBarCodeList()
    },
    getBarCodeList() {
      let _data = {
        "path": "ChildOrder/BarCodeList",
        "parms": "",
        "parmsJson": this.codeForm
      }
      KSAXApiRequest(_data).then((res) => {
        this.loading = false;
        this.barcodeList = res.data.response.data || [];
        this.codeTotal = res.data.response.dataCount || 0;
      });
    },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      });
    },
    splitArr(str) {
      if (str) {
        return str.split(",");
      } else {
        return [];
      }
    },
    searchBtn() {
      this.searchData.PageIndex = 1;
      this.getTableData();
    },
    resetBtn() {
      this.searchData = {
        AccountId: null,
        SearchKeyType: 1,
        SearchKey: null,
        AccountType: null,
        ApplyInstallStatus: '1',
        ContactPhone: null,
        ContactName: null,
        StartTime: null,
        InstallTimeBegin: null,
        InstallTimeEnd: null,
        EndTime: null,
        PageIndex: 1,
        PageSize: 10,
        SupIds: [],
        IsBarCodeBind: this.searchData.IsBarCodeBind,
        IsRobot: null,
        SelectNumber: -1,
        RemainNumber: 3
      };
      this.supmodelData.name = null;
      this.value = []
      this.getTableData();
    },
    // 处理
    handle(row) {
      this.handleDialog = true;
      this.handleForm.ApplyInstallId = row.applyInstallId;
      this.handleForm.Status = 2;
      this.handleForm.Remark = null;
    },
    handleSubmit() {
      let _data = {
        "path": "Order_ApplyInstall/ApplyInstallStatusChange",
        "parms": "",
        "parmsJson": this.handleForm
      }
      KSAXApiRequest(_data).then((res) => {
        if (res.data.success) {
          this.$message.success("处理成功");
          if (this.handleForm.Status === 2) {
            this.tableData = this.tableData.filter(item => item.applyInstallId !== this.handleForm.ApplyInstallId)
          }
          this.getTableData();
          this.handleDialog = false;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 处理记录
    handleRecord(row) {
      this.handleRecordDialog = true;
      this.handleRecordData = row.remarks;
    },
    // 订单详情
    // handleOrderDetail(row) {
    //   this.$router.push(
    //     `/Order/OrderManagement/OrderDetail?orderid=${row.OrderId}`
    //   );
    // },
    // handleDelete(row) {
    //   // 删除报装订单
    //   this.$confirm("是否确认删除?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     closeOnClickModal: false,
    //     type: "warning",
    //   })
    //     .then(() => {
    //       let params = [row.ApplyInstallId];
    //       let that = this;
    //       ApplyInstallDelete(params).then((res) => {
    //         if (res.data.success) {
    //           that.$message.success(res.data.msg);
    //           that.getTableData();
    //         } else {
    //           that.$message.error(res.data.msg);
    //         }
    //       });
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    // updata(e) {
    //   let index1 = e.raw.name.lastIndexOf(".") + 1;
    //   let index2 = e.raw.name.length;
    //   let type = e.raw.name.substring(index1, index2);
    //   if (type != "xlsx")
    //     return this.$message.error("请上传文件格式为xlsx文件");
    //   this.file = e.raw;
    // },
    // upDataInfo() {
    //   window.open(
    //     "https://homeimage.ksaxshop.com/%E8%AE%A2%E5%8D%95%E6%8A%A5%E8%A3%85%E6%89%A9%E5%B1%95%E6%A8%A1%E6%9D%BF%20%281%29.xlsx"
    //   );
    // },
    // handleExpSubmit() {
    //   let that = this;
    //   that.uploading = true;
    //   let formData = new window.FormData();
    //   formData.append("formFile", that.file);
    //   BindExternalInstall(formData).then((res) => {
    //     that.uploading = false;
    //     that.bindVisible = false;
    //     if (res.data.success) {
    //       that.$message.success(res.data.msg);
    //       that.getTableData();
    //     } else {
    //       that.$message.error(res.data.msg);
    //     }
    //   });
    // },
    // handleBindExternalInstall() {
    //   this.bindVisible = true;
    // },
    selectCurrentRow(row) {
      this.checkedData = row
    },
    // batchBarCodeUpdate(row) {
    //   this.$confirm('确定匹配通过?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     ChildOrderBatchBarCodeUpdate({
    //       installIds: row.ApplyInstallId ? [row.ApplyInstallId] : this.checkedData.map(item => {
    //         return item.ApplyInstallId
    //       })
    //     }).then((res) => {
    //       if (res.data.success) {
    //         this.$message.success(res.data.msg);
    //         this.getTableData();
    //       } else {
    //         this.$message.error(res.data.msg);
    //       }
    //     });
    //   })
    // },
    // applyInstallRobotTime(row) {
    //   this.$confirm('确认已跑?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     ApplyInstallRobotTime({ Id: row.ApplyInstallId }).then((res) => {
    //       if (res.data.success) {
    //         this.$message.success(res.data.msg);
    //         this.getTableData();
    //       } else {
    //         this.$message.error(res.data.msg);
    //       }
    //     });
    //   })
    // },
    copyInfo() {
      const inputDom = document.createElement('textarea');
      document.body.appendChild(inputDom)
      inputDom.value = `${this.row.ChildOrderNo}
${this.row.modelCode}
${this.row.contactName}${this.row.contactPhone}${this.row.provinceName}${this.row.cityName}${this.row.districtName}${this.row.address}
报装${this.row.ApplyNumber}台
${this.barcodeList.map(item => {
        return item.code
      })}`
      inputDom.select()
      inputDom.focus()
      document.execCommand('copy')
      document.body.removeChild(inputDom)
      this.$message.success('复制成功')
    }
  },
  watch: {
    'modifyForm.ProvinceId'(n, o) {
      if (n) {
        this.getCityList()
      }
    },
    'modifyForm.CityId'(n, o) {
      if (n) {
        this.getAreaList()
      }
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    const toolBarButtonList = buttonList.filter((item) => {
      return item.ButtonType === 10 && item.Func;
    });
    this.buttonList_toolBar = toolBarButtonList;
    this.isOperateBtn = buttonList.find((i) => i.Func == "operateBtn");
    this.isOperateRecord = buttonList.find((i) => i.Func == "operateRecord");
    const tableButtonList = buttonList.filter((item) => {
      return item.ButtonType === 20;
    });
    this.buttonList_table = tableButtonList;
  },
};
</script>
<style scoped>
.repair-order {
  padding: 0 20px 50px;
}

.remark-box {
  border: 1px solid #999;
  margin-bottom: 10px;
}

.remark-box span {
  display: inline-block;
}

.time-box {
  border-bottom: 1px solid #999;
  padding: 10px;
}

.remark-txt {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.remark-txt span:nth-child(2) {
  flex: 1;
}

.purchaseInfo {
  white-space: normal;
  height: auto;
}

.updateTitle {
  font-size: 16px;
  color: #333;
  margin-bottom: 15px;
}

.updateTitle span {
  font-size: 13px;
  color: red;
  margin-left: 10px;
}
</style>
